// import { storeStructure } from '../store/reducers';
import tableTagManager from './tableTagManager';
export default {
  title: 'Tag Manager',
  attributeName: "tagmanager",
  getURL: 'tagmanager',
  createURL: 'tagmanager',
  removeURL: 'tagmanager',
  sessionParams: [],
  noArea: true,
  tableConfig: tableTagManager,
  autoUpdate: true,
};
